<app-ktidentity-mfa *ngIf="ktidentityChallenge" [challenge]="ktidentityChallenge" [email]="ktidentityEmail"
  (completed)="onKtidentityCompleted($event)" (failed)="onKtidentityFailed($event)" (cancelled)="onKtidentityCancelled()">
</app-ktidentity-mfa>

<section class="container-login twoGrid">
  <div class="left-container">
    <div class="img-logo">
      <img *ngIf="!externallogin || externallogin === 'docsia'" [src]="logoSrc" alt="Docs IA" />
      <img src="assets/img/atvos.png" *ngIf="externallogin==='atvos'" alt="Atvos" />
      <img src="assets/img/allianz.png" *ngIf="externallogin==='allianz'" alt="Allianz" />
      <img src="assets/img/tokio.png" *ngIf="externallogin==='tokio'" alt="Tokio" />
    </div>

    <form *ngIf="showLoginBox" class="formGroup" (ngSubmit)="login()" #loginForm="ngForm">
      <div class="inputGroup">
        <label for="eml" class="visually-hidden">{{translate.instant('LOGIN.email')}}</label>
        <input type="email" class="form-control" [placeholder]="translate.instant('LOGIN.user')" required
          autocomplete="email" id="eml" name="eml" [(ngModel)]="$any(user).email" #eml="ngModel">
      </div>

      <div class="inputGroup">
        <label for="passwd" class="visually-hidden">{{translate.instant('LOGIN.password')}}</label>
        <app-password-input class="pass" iconSet="icofont" id="passwd" name="passwd" [placeholder]="translate.instant('LOGIN.password')"
          autocomplete="current-password" required [(ngModel)]="$any(user).password" #passwd="ngModel"></app-password-input>
      </div>

      <div class="inputGroup">
        <button type="submit" class="btn btn-primary">{{translate.instant('LOGIN.logIn')}}</button>
      </div>

      <ng-container *ngIf="ktidentityEnabled">
        <div class="login-separator"><span>{{translate.instant('LOGIN.or')}}</span></div>
        <div class="inputGroup">
          <button type="button" class="btn btn-ktidentity" (click)="loginKtidentity()">
            {{translate.instant('LOGIN.ktidentity.signInWith', { label: ktidentityLabel })}}
          </button>
        </div>
      </ng-container>

      <div class="forgotPwd">
        <a routerLink="/pages/recovery">{{translate.instant('LOGIN.forgotMyPassword')}}</a>
      </div>
    </form>

    <form *ngIf="!showLoginBox" class="formGroup">
      <p class="sso-msg">{{translate.instant('LOGIN.logInWithCorporateId')}}</p>
      <div class="inputGroup">
        <button *ngIf="externallogin==='atvos'" type="button" class="btn btn-primary" (click)="authorization_external_provider()">Azure AD</button>
        <button *ngIf="externallogin==='allianz'" type="button" class="btn btn-primary" (click)="authorization_external_provider()">Allianz AD</button>
        <button *ngIf="externallogin==='tokio'" type="button" class="btn btn-primary" (click)="authorization_external_provider()">Tokio AD</button>
        <button *ngIf="externallogin==='docsia'" type="button" class="btn btn-primary" (click)="authorization_external_provider()">Docsia AD</button>
      </div>
    </form>

    <!-- Change Language -->
    <div class="flag" dropdown>
      <button class="btn dropdown-toggle btn-flag" dropdownToggle role="button" aria-controls="hboot"
        data-bs-toggle="dropdown" aria-expanded="false" type="button">
        <span id="teste">{{translate.instant(lang)}} <img [src]="flag" alt=""></span>
      </button>
      <ul class="dropdown-menu" *dropdownMenu id="hboot" aria-labelledby="dropdownMenuButton1" role="menu">
        <div>
          <li class="dropdown-item" (click)="changLang('pt')"><img src="/assets/icon/flag/pt.svg" alt="">
            <span>{{ translate.instant('pt')}}</span>
          </li>
          <li class="dropdown-item" (click)="changLang('en')"><img src="/assets/icon/flag/en.svg" alt="">
            <span>{{translate.instant('en')}}</span>
          </li>
          <li class="dropdown-item" (click)="changLang('es')"><img src="/assets/icon/flag/es.svg" alt="">
            <span>{{translate.instant('es')}}</span>
          </li>
          <li class="dropdown-item" (click)="changLang('fr')"><img src="/assets/icon/flag/french.svg" alt="">
            <span>{{translate.instant('fr')}}</span>
          </li>
        </div>
      </ul>
    </div>

    <a *ngIf="showDevelopedBy" class="login-powered" href="https://www.ktgroup.com.br/" target="_blank" rel="noopener noreferrer"
      title="KT Group">
      <span class="login-powered__rotulo">{{translate.instant('LOGIN.developedBy')}}</span>
      <img class="login-powered__logo" src="assets/img/login/ktgroup-logo.png" alt="KT Group" />
    </a>
  </div>

  <div class="right-container">
    <div class="text-login">
      <h1>{{translate.instant('LOGIN.welcome')}}</h1>
      <span>{{translate.instant('LOGIN.welcomeSubtitle')}}</span>
    </div>
    <img class="illustration" src="assets/img/login/login-illustration.svg" alt="" />
  </div>
</section>
